/* global localStorage */
import _ from 'lodash'

// get data form localStorage of browser
export const loadLocal = keyName => {
  try {
    const serializedValue = localStorage.getItem(keyName)
    return _.isNull(serializedValue)
      ? null
      : JSON.parse(serializedValue)
  } catch (error) {
    return null
  }
}

// save data into localStorage
export const saveIntoLocal = (keyName, value) => {
  const serializedValue = JSON.stringify(value)
  localStorage.setItem(keyName, serializedValue)
}

// remove data in localStorage
export const removeLocal = keyName => localStorage.removeItem(keyName)
